<template>
  <div
    class="flex flex-row justify-between gap-3 p-3 rounded-lg w-full border border-1"
    :class="selected ? 'border-BLACK' : 'border-LIGHTGREY'"
    @click="handleClick"
  >
    <div class="flex flex-row gap-3 items-center">
      <div class="flex flex-col justify-center items-center rounded-lg p-2 bg-LIGHTGREY w-9 h-9">
        <img v-if="token.icon" :src="token.icon" class="w-6 h-8 object-contain" />
        <img v-else src="@/assets/images/empty-img.svg" class="w-6 h-8 object-contain" />

      </div>
      <div class="flex flex-col gap-1 justify-between items-start">
        <p class="text-sm font-semibold text-BLACK">{{ token.name }}</p>
        <div class="flex flex-row gap-1 text-GREY text-xs">
          Rate
          <img src="../assets/icons/token-2.svg" class="w-4 h-4 object-contain" />
          {{ token.rate }}
        </div>
      </div>
    </div>
    <div class="flex flex-row items-center justify-center">
      <font-awesome-icon v-if="selected" class="black-icon" icon="fa-solid fa-check" />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  token: {
    type: Object,
    required: true
  },
  selected: {
    type: Boolean,
    required: false,
    default: false
  }
})

const emit = defineEmits(['update:selected'])

const handleClick = () => {
  emit('update:selected')
}
</script>
